export default __webpack_public_path__ + "static/media/Ass 7.c21fe8ef.png";